import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    mbHeroSlider();
});

function mbHeroSlider() {
    var swipers = document.querySelectorAll('.swiper.slider-hero');

    swipers.forEach(function(swiper) {

        var swiperSlider = new Swiper(swiper, {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            speed: 500,
            //effect: 'fade',
            slidesPerView: 1,
            allowTouchMove: false,
            touchStartPreventDefault: false,
            simulateTouch: false,
            keyboard: {
                enabled: false
            },
            direction: 'vertical',
            breakpoints: {
                0: {
                    direction: 'horizontal'
                },
                768: {
                    direction: 'vertical'
                }
            },
            navigation: {
                nextEl: '.custom-button-next',
                prevEl: '.custom-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        });
    });
}
